import { Box, theme } from '@/components';
import { Badge, Image, type ImageProps } from 'antd';
import { type CSSProperties, type FC, useState } from 'react';
import { ImagePreviewMask } from './ImagePreviewMask';

type Props = {
  wrapperStyle?: CSSProperties;
  showPreview?: boolean;
  order?: number;
} & Pick<ImageProps, 'src' | 'alt' | 'style'>;

export const AttachedImage: FC<Props> = ({
  src,
  alt,
  style: imageStyle,
  wrapperStyle,
  showPreview = false,
  order,
}) => {
  const { token } = theme.useToken();
  const [isLandscape, setIsLandscape] = useState(false);

  return (
    <Box
      width="100%"
      height="auto"
      aspectRatio={isLandscape ? 'auto' : 1}
      padding={8}
      display="flex"
      justifyContent="center"
      backgroundColor={token.colorBgContainerDisabled}
      position="relative"
      {...wrapperStyle}
    >
      {order && (
        <Box position="absolute" left={8} top={8} zIndex={1}>
          <Badge count={order} color={token.colorPrimary} />
        </Box>
      )}
      <Image
        src={src}
        alt={alt}
        preview={showPreview ? { mask: <ImagePreviewMask /> } : false}
        onClick={() => {
          if (!showPreview) {
            window.open(src, '_blank');
          }
        }}
        onLoad={(event) => {
          if (event.target instanceof HTMLImageElement) {
            setIsLandscape(
              event.target.naturalWidth > event.target.naturalHeight,
            );
          }
        }}
        width="100%"
        height="100%"
        style={{
          cursor: 'pointer',
          objectFit: 'contain',
          objectPosition: '50% top',
          aspectRatio: isLandscape ? 'auto' : 1,
          ...imageStyle,
        }}
      />
    </Box>
  );
};
